/**
 * The default value for the rich text input. We watch for this and emit `""` instead, since that's
 * what calling code typically expects from an empty input.
 *
 * @default "<p></p>"
 */
export const RICH_TEXT_INPUT_EMPTY_VALUE = "<p></p>";

/* eslint-disable lingui/no-unlocalized-strings */

/**
 * The list of HTML tags that we allow to be rendered in the rich text input and display values.
 *
 * Please keep this in sync with `RICH_TEXT_INPUT_SUPPORTED_HTML_TAGS` in `email-renderer`.
 */
export const RICH_TEXT_INPUT_SUPPORTED_HTML_TAGS = [
  "a",
  "blockquote",
  "br", // Necessary for respecting line breaks when duplicating legacy plain-text tasks that are still in the database as such
  "code",
  "em",
  "li",
  "ol",
  "p",
  "pre",
  "s",

  // Warning: Should be retained if and only if there are also attributes on this tag, else its
  // presence causes TipTap to render the whole string as raw HTML visible to the user. We remove
  // attribute-less spans in a post-processing step.
  "span",

  "strong",
  "u",
  "ul",
];

/**
 * The list of HTML attributes that we allow to be rendered in the rich text input and display
 * values.
 *
 * Please keep this in sync with `RICH_TEXT_INPUT_SUPPORTED_ATTRIBUTES` in `email-renderer`.
 */
export const RICH_TEXT_INPUT_SUPPORTED_ATTRIBUTES = [
  "data-field-id",
  "data-field-instance-id",
  "data-icon-name",
  "data-mention-id",
  "data-mention-label",
  "data-regrello-object-property-id",
  "data-source-field-instance-id",
  "data-type",
  "href",
  // "rel" - explicitly not supported because it's a security risk
  // "target" - explicitly not supported because it's a security risk
];
/* eslint-enable lingui/no-unlocalized-strings */
